/* eslint-disable */


/**
 * Intents related to Compliance information.
 * Typically restricted to Admins/Compliance users.
 */
export const COMPLIANCE_INTENTS = [
    'compliance_readiness_view',
    'compliance_gaps_view',
    'compliance_control_view',
    'compliance_report_generate',
    'audit_logs_view',
    'policy_framework_mapping_view',
];

/**
 * Intents related to Policy information.
 * Available to all Policy users.
 */
export const POLICY_INTENTS = [
    'navigate',
    'policy_search',
    'policy_open',
    'template_search',
    'policy_create_from_template',
    'policy_export_pdf',
    'policy_export_batch_pdf',
    'policy_show_acknowledgements',
    'policy_show_approvals',
    'policy_show_revision_history',
    'help',
    'clarify',
];

/**
 * Full access (Main Compliance App)
 */
export const FULL_ACCESS_INTENTS = [
    ...POLICY_INTENTS,
    ...COMPLIANCE_INTENTS,
];
